'use client'

import { html } from '@ensemble.music/ui'
import { type Benefit, benefits as bookerBenefits } from './content'
import { SectionHeading } from './SectionHeading'

export function Benefits({
  items = bookerBenefits,
  title = 'Weniger Suchen, mehr Musik',
  lead = 'Wir nehmen dir die Recherche ab und liefern Angebote, die du nebeneinanderlegen kannst.',
}: {
  items?: readonly Benefit[]
  title?: string
  lead?: string
} = {}) {
  return (
    <html.section
      id="vorteile"
      className="flex flex-col gap-12"
    >
      {/* Centred, and the only centred head on the page: the section is a list of claims, not a
          step sequence, so it reads from the middle out. */}
      <SectionHeading
        layout="center"
        title={title}
        lead={lead}
      />

      {/* A ruled grid instead of boxes (owner, 2026-10-19): hairlines only between the claims,
          no outer frame, and a short blue tick on each cell that runs along its line on hover.
          Three per row, or two when the count does not fill rows of three. The lines and the
          tick live in style.css; custom classes stay on plain DOM elements (see HowItWorks). */}
      <div
        className={
          items.length % 3 === 0 ? 'landing-benefits' : 'landing-benefits landing-benefits--two'
        }
      >
        {items.map((benefit) => (
          <div
            key={benefit.title}
            className="landing-benefit"
          >
            <html.span className="inline-flex flex-row items-center text-primary-text">
              <benefit.icon
                size={24}
                aria-hidden="true"
              />
            </html.span>
            <html.h3 className="text-xl font-semibold tracking-tight text-color">
              {benefit.title}
            </html.h3>
            <html.p className="text-base text-color-secondary">{benefit.body}</html.p>
          </div>
        ))}
      </div>
    </html.section>
  )
}
